import IFileService from 'data/IFileService';
import DocumentSimplifiedDTO from 'features/invoices/dtos/DocumentSimplifiedDTO';
import RoundButton from 'features/shared/components/buttons/RoundButton';
import { useInjection } from 'infrastructure/ioc/ioc.react';
import { IocTypes } from 'infrastructure/ioc/ioc.types';
import React from 'react';

interface Props {
  document: DocumentSimplifiedDTO;
}

const RequirementDocument = ({ document }: Props) => {
  // DI
  const fileService = useInjection<IFileService>(IocTypes.FileService);

  // hadlers
  const fileDownloadHandler = () => {
    fileService.downloadDocument(document);
  }

  // render
  return (
    <div className="row no-gutters align-items-center">
      <div className="col">
        <div>
          {document.name}
        </div>
        <div className="text-muted small">
          {document.documentType}
        </div>
      </div>
      <div className="col-auto pl-3">
        <RoundButton icon="file-pdf" onClickHandler={fileDownloadHandler} />
      </div>
    </div>
  )
}

export default RequirementDocument;
